import routes from '@/modules/document-template/document-template-routes';
import store from '@/modules/document-template/document-template-store';

export default {
    routes,
    store,
}
